/**
 * DevExtreme (data/query_adapters.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/data/query_adapters.js
// module id = 1012
// module chunks = 0